import PropTypes from 'prop-types';

const CheckMark = ({
  className = '',
  color = '#32B496',
  size = 14,
  ...restProps
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    className={className}
    {...restProps}
  >
    <path
      d="M20.285 2l-11.285 11.567-5.286-5.011-3.714 3.716 9 8.728 15-15.285z"
      fill={color}
    />
  </svg>
);

CheckMark.propTypes = {
  color: PropTypes.string,
  className: PropTypes.string,
  size: PropTypes.number
};

export default CheckMark;
